
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
@Component({
  standalone: true,
  imports: [CommonModule, AutoCompleteModule, FormsModule],
  selector: 'app-search-autocomplete',
  templateUrl: './search-autocomplete.component.html',
  styleUrls: ['./search-autocomplete.component.scss']
})
export class SearchAutocompleteComponent {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() placeholder: string = '';
  @Input() disabledBool: boolean = false;
  @Input() disableStyle: boolean = false;

  @Input() items: any[] = []; // Datos de entrada
  @Output() itemSelected = new EventEmitter<any>(); // Evento de salida

  selectedItem: any;
  filteredItems: any[] = [];

  ngOnInit() {
    this.filteredItems = [...(this.items ?? [])];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.filteredItems = [...(this.items ?? [])];
    }
  }

  filterItems(event: any): void {
    const query = String(event?.query ?? '').trim().toLowerCase();
    const items = Array.isArray(this.items) ? this.items : [];

    this.filteredItems = items.filter(item => {
      const name = String(item?.name ?? '').toLowerCase();
      const description = String(item?.description ?? '').toLowerCase();

      return name.includes(query) || description.includes(query);
    });
  }

  onSelect(event: any): void {
    this.itemSelected.emit(event.value);
  }
}
